import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  footer: {
    padding: theme.spacing(6, 4),
    textAlign: 'center',
    background: theme.palette.extras.slate,
  },

  slogan: {
    textAlign: 'left',
    marginBottom: theme.spacing(4),
    fontFamily: 'Roboto Condensed',
    fontStyle: 'italic',
    fontSize: theme.typography.h4.fontSize,
    color: theme.palette.text.disabled,
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.h3.fontSize,
    },
  },

  links: {
    padding: theme.spacing(2, 0),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& a': {
      padding: theme.spacing(1),
      margin: theme.spacing(0),
      transition: theme.transitions.default,
      color: theme.palette.text.disabled,
      textDecoration: 'none',
      textTransform: 'uppercase',
      fontSize: theme.typography.caption.fontSize,
      fontWeight: theme.typography.fontWeightBold,
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 2),
        borderRight: `1px solid ${theme.palette.text.disabled}`,
      },
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      '& :hover': {
        fontWeight: theme.typography.fontWeightRegular,
      },
      '& a:last-child': {
        borderRight: 'none',
      },
    },
  },
  icons: {
    '& a': {
      display: 'inline-block',
      margin: theme.spacing(2),
      fontSize: theme.typography.h5.fontSize,
      color: theme.palette.text.white,
      transition: theme.transitions.default,
    },
    [theme.breakpoints.up('md')]: {
      '& :hover': {
        color: theme.palette.primary.main,
      },
    },
  },
  copyright: {
    letterSpacing: theme.typography.letterSpacing,
    lineHeight: 2,
    textTransform: 'uppercase',
    color: theme.palette.text.disabled,
    fontSize: theme.typography.caption.fontSize,
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 360,
    textAlign: 'left',
  },

  subheader: {
    padding: theme.spacing(0),
    lineHeight: theme.spacing(0.25),
  },

  sectionTitle: {
    color: theme.palette.text.mainLight,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'uppercase',
    fontFamily: 'Roboto Condensed',
  },

  footerNavItem: {
    padding: theme.spacing(0),
    margin: theme.spacing(1.5, 0),
  },

  footerNavItemLink: {
    textDecoration: 'none',
    color: theme.palette.text.white,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightLight,
  },

  footerNavSection: {
    marginBottom: theme.spacing(2),
  },
}))
